// app/javascript/components/shared/ui/Badge.js
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const badgeVariants = cva(
  "inline-flex items-center font-semibold whitespace-nowrap",
  {
    variants: {
      tone: {
        neutral:    "",
        brand:      "",
        success:    "",
        warning:    "",
        danger:     "",
        lime:       "",
        orange:     "",
        blue:       "",
        emerald:    "",
        amber:      "",
        rose:       "",
        violet:     "",
        slate:      "",
        section:    "",
        subsection: "",
        group:      "",
      },
      variant: {
        solid:   "border-0 text-white",
        soft:    "ring-1 ring-inset",
        outline: "bg-white border ring-0",
      },
      size: {
        xs: "text-[10px] px-1.5 py-0.5 rounded-full",
        sm: "text-[11px] px-2 py-0.5 rounded-md",
        md: "text-xs px-2.5 py-1 rounded-md",
      },
    },
    compoundVariants: [
      { variant: "solid", tone: "neutral",    class: "bg-slate-500" },
      { variant: "solid", tone: "brand",      class: "bg-brand-500" },
      { variant: "solid", tone: "success",    class: "bg-emerald-500" },
      { variant: "solid", tone: "warning",    class: "bg-amber-500" },
      { variant: "solid", tone: "danger",     class: "bg-rose-500" },
      { variant: "solid", tone: "section",    class: "bg-section-500" },
      { variant: "solid", tone: "subsection", class: "bg-subsection-500" },
      { variant: "solid", tone: "group",      class: "bg-group-500" },

      { variant: "soft", tone: "neutral",    class: "bg-slate-50 text-slate-700 ring-slate-200" },
      { variant: "soft", tone: "brand",      class: "bg-brand-50 text-brand-700 ring-brand-200" },
      { variant: "soft", tone: "success",    class: "bg-emerald-50 text-emerald-700 ring-emerald-200" },
      { variant: "soft", tone: "warning",    class: "bg-amber-50 text-amber-700 ring-amber-200" },
      { variant: "soft", tone: "danger",     class: "bg-rose-50 text-rose-700 ring-rose-200" },
      { variant: "soft", tone: "lime",       class: "bg-lime-50 text-lime-700 ring-lime-200" },
      { variant: "soft", tone: "orange",     class: "bg-orange-50 text-orange-700 ring-orange-200" },
      { variant: "soft", tone: "blue",       class: "bg-blue-50 text-blue-700 ring-blue-200" },
      { variant: "soft", tone: "emerald",    class: "bg-emerald-50 text-emerald-700 ring-emerald-200" },
      { variant: "soft", tone: "amber",      class: "bg-amber-50 text-amber-700 ring-amber-200" },
      { variant: "soft", tone: "rose",       class: "bg-rose-50 text-rose-700 ring-rose-200" },
      { variant: "soft", tone: "violet",     class: "bg-violet-50 text-violet-700 ring-violet-200" },
      { variant: "soft", tone: "slate",      class: "bg-slate-50 text-slate-700 ring-slate-200" },
      { variant: "soft", tone: "subsection", class: "bg-subsection-50 text-subsection-500 ring-subsection-500/20" },
      { variant: "soft", tone: "group",      class: "bg-group-50 text-group-500 ring-group-500/25" },

      { variant: "outline", tone: "neutral", class: "border-slate-300 text-slate-700" },
      { variant: "outline", tone: "brand",   class: "border-brand-300 text-brand-700" },
    ],
    defaultVariants: { tone: "neutral", variant: "soft", size: "sm" },
  }
)

const Badge = ({ tone, variant, size, className, ...props }) => (
  <span className={clsx(badgeVariants({ tone, variant, size }), className)} {...props} />
)

export default Badge
